import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDialogData, CommonDialogButton } from 'src/app/components/common-dialog/models/common-dialog.model';

@Component({
  selector: 'common-dialog',
  templateUrl: './common-dialog.component.html',
})
export class CommonDialogComponent {
  title: string = '';
  message: string = '';
  type: string = 'info';
  confirmButtonText: string = 'Yes';
  cancelButtonText: string = 'Cancel';
  showCancelButton: boolean = true;
  isLoading: boolean = false;
  payload: any;
  customButtons: CommonDialogButton[] = [];

  constructor(
    public dialogRef: MatDialogRef<CommonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CommonDialogData
  ) {
    if (data) {
      this.title = data.title ?? this.getDefaultTitle(data.type);
      this.message = data.message;
      this.type = data.type ?? 'info';
      this.confirmButtonText = data.confirmText ?? this.getDefaultConfirmText(data.type);
      this.cancelButtonText = data.cancelText ?? 'Cancel';
      this.showCancelButton = data.showCancel !== undefined ? data.showCancel : true;
      this.payload = data.payload;
      this.customButtons = data.customButtons || [];
    }
  }

  getDefaultTitle(type?: string): string {
    switch (type) {
      case 'confirm': return 'Confirm';
      case 'warning': return 'Warning';
      case 'error': return 'Error';
      case 'success': return 'Success';
      case 'info':
      default:
        return 'Information';
    }
  }

  getDefaultConfirmText(type?: string): string {
    return type === 'confirm' ? 'Yes' : 'OK';
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true, payload: this.payload });
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false, payload: this.payload });
  }

  onCustomButtonClick(button: CommonDialogButton): void {
    this.dialogRef.close({ confirmed: true, action: button.value, payload: this.payload });
  }
}
